import React, { useState } from "react";
import { CircularProgress } from "@mui/material";
import { globalStyle } from "../../global/Utils";
import ExcelLogo from "../../Images/excelLogo.jpg";

const DownloadTemplateModal = ({ isOpen, onClose }) => {
  const [isDownloading, setIsDownloading] = useState(false);

  if (!isOpen) return null;

  const handleDownload = () => {
    setIsDownloading(true);

    const link = document.createElement("a");
    link.href = "https://res.cloudinary.com/dt3gwqh02/raw/upload/v1776431494/invoice-template_f89t7i.xlsx"; // must be in public folder
    link.download = "Bulk_Invoice_Template.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setTimeout(() => {
      setIsDownloading(false);
    }, 1000);
  };

  return (
    <div className="fixed inset-0 z-[1500] flex items-center justify-center bg-black/40 p-4">
      {/* Modal Box */}
      <div className="bg-white w-full max-w-3xl rounded-xl shadow-lg max-h-screen flex flex-col">
        {/* Header */}
        <div className="flex justify-between items-center border-b px-5 py-3 shrink-0">
          <h2 className="text-lg font-semibold">Download Template File</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-black text-xl"
          >
            ✕
          </button>
        </div>

        {/* Body (Scrollable) */}
        <div className="p-5 space-y-6 overflow-y-auto">
          {/* Info Box */}
          <div className="bg-blue-50 border border-blue-200 text-blue-900 rounded-lg p-4">
            <h6 className="font-semibold mb-2">Template File Instructions</h6>
            <p className="mb-2 font-medium">
              Download the template file and fill it with your invoice data:
            </p>
            <ul className="list-disc pl-5 space-y-1 text-sm">
              <li>Use the template to ensure proper formatting</li>
              <li>Do not modify the column sequence but can change headings</li>
              <li>All columns data is required other then UOM and QTY</li>
              <li>At least one of Customer NTN or CNIC is required</li>
              <li>Date format: Month/Day/Year (e.g., 7/4/2025)</li>
            </ul>
          </div>

          {/* Template Section */}
          <div>
            <h6 className="font-semibold mb-3">Available Template Formats:</h6>

            <div className="border rounded-lg p-5 text-center shadow-sm hover:shadow-md transition">
              <img
                src={ExcelLogo}
                alt="Excel Logo"
                className="w-16 h-16 object-contain mx-auto mb-3"
              />
              <h5 className="font-semibold text-lg">Excel Template</h5>
              <p className="text-gray-500 text-sm mb-4">
                Recommended for easy data entry
              </p>

              <button
                onClick={handleDownload}
                disabled={isDownloading}
                className="px-4 py-2 rounded-md text-white text-sm font-semibold disabled:opacity-50 flex items-center justify-center gap-2 mx-auto"
                style={{ background: globalStyle.buttonColor }}
              >
                {isDownloading ? (
                  <>
                    <CircularProgress size={16} color="inherit" />
                    Please wait...
                  </>
                ) : (
                  "Download Excel"
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end border-t px-5 py-3 shrink-0">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-md bg-gray-200 hover:bg-gray-300 text-sm"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default DownloadTemplateModal;
